import { render, staticRenderFns } from "./IadeEkle.vue?vue&type=template&id=93fbebb6"
import script from "./IadeEkle.vue?vue&type=script&lang=js"
export * from "./IadeEkle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports